import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-64 flex-shrink-0">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              最新动态
            </h2>
            <p className="text-sm text-foreground-600">
              追更日历与平台动态，实时掌握最新上线内容和功能更新
            </p>
          </div>

          <div className="flex-1">
            <div className="relative pl-6 border-l-2 border-background-200/60">
              {updatesData.map((item, index) => (
                <div
                  key={item.id}
                  className={`relative pb-8 ${index === updatesData.length - 1 ? 'pb-0' : ''}`}
                >
                  <div className="absolute -left-[25px] top-0 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100"></div>
                  <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                    <span className="text-xs font-medium text-primary-400 bg-primary-500/10 px-2 py-0.5 rounded whitespace-nowrap w-fit">
                      {item.date}
                    </span>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1">
                        {item.title}
                      </h3>
                      <span className="inline-block text-xs font-medium text-accent-500 bg-accent-500/10 px-2 py-0.5 rounded whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}